<template>
  <div class="relative flex flex-col w-full h-full items-center justify-center">
    <img src="/assets/404.svg" class="w-80 h-80" />
    <h1 class="text-5xl text-slate-200 font-">Page not found</h1>
    <a
      class="flex lg:hidden mt-8 w-48 h-8 items-center justify-center text-sm rounded-sm text-gray-300 border border-cetoSurfaceMidEmph hover:cursor-pointer hover:border-slate-200"
      @click="goBack"
      ><span>Go back</span></a
    >
    <h2 class="hidden lg:flex text-slate-200 mt-8 font-thin">
      It was probably&nbsp;
      <a href="https://github.com/christywastaken" target="_blank" rel="noopener noreferrer" class="relative z-30 hover:text-cetoLime1"
        >Christian's</a
      >
      &nbsp;fault
    </h2>
    <div class="hidden lg:flex relative flex-col mt-2 w-[500px] h-40 justify-end">
      <img src="/marketing/misc/squiggly_arrow.png" class="absolute top-0" />
      <div class="relative flex w-full mt-2 justify-between z-20">
        <a
          href="https://ceto.ai/contact"
          class="flex w-48 h-8 items-center justify-center text-sm rounded-sm text-gray-300 border border-cetoSurfaceMidEmph hover:cursor-pointer hover:border-slate-200"
          ><span>Sign his P45</span></a
        >
        <!-- a tags used as I'm fairly sure nuxt router / NuxtLink is not availble in error.vue -->
        <a
          class="flex w-48 h-8 items-center justify-center text-sm rounded-sm text-gray-300 border border-cetoSurfaceMidEmph hover:cursor-pointer hover:border-slate-200"
          @click="goBack"
          ><span>Go back</span></a
        >
      </div>
    </div>
    <div class="hidden lg:flex absolute bottom-0 w-full items-center z-0">
      <img src="/marketing/misc/sexy_engineer.png" class="h-[500px]" />
    </div>
  </div>
</template>

<script setup lang="ts">
const goBack = () => {
  window.history.back()
}
</script>
